export const internDetailsTranslations = {
  lv: {
    title: 'Praktikants',
    diary: 'Dienasgrāmata',
    info: 'Prakses informācija',
    pdf: 'Dienasgrāmata PDF',
    group: 'Grupa',
    internship: 'Prakse',
    period: 'Periods',
    ends: 'Beidzas',
    supervisor: 'Prakses vadītājs pie mums',
    school: 'Izglītības iestāde',
    loadError: 'Neizdevās ielādēt praktikanta informāciju.',
    unavailable: 'Praktikants nav atrasts vai jums nav piekļuves šim norīkojumam.',
    back: 'Atpakaļ uz praktikantiem',
    workplace: 'Darba vieta',
    duration: 'Ilgums',
    workplaces: {
      OnSite: 'Prakses vietā',
      Remote: 'Attālināti',
      Mixed: 'Jaukts',
      Dynamic: 'Mainīga',
      NotSet: 'Nav norādīta',
    },
    empty: 'Šim norīkojumam vēl nav dienasgrāmatas ierakstu.',
  },
  en: {
    title: 'Intern',
    diary: 'Diary',
    info: 'Internship information',
    pdf: 'Diary PDF',
    group: 'Group',
    internship: 'Internship',
    period: 'Period',
    ends: 'Ends',
    supervisor: 'Supervisor at our workplace',
    school: 'Educational institution',
    loadError: 'Could not load intern information.',
    unavailable: 'The intern was not found or you do not have access to this placement.',
    back: 'Back to interns',
    workplace: 'Work location',
    duration: 'Duration',
    workplaces: {
      OnSite: 'On site',
      Remote: 'Remote',
      Mixed: 'Mixed',
      Dynamic: 'Variable',
      NotSet: 'Not specified',
    },
    empty: 'This placement has no diary entries yet.',
  },
}
